/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventGroupsSeoFormComponent } from '@app/events/events-groups/event-groups-seo-form/event-group-seo-form.component';
import { EventGroup } from '@app/events/events-groups/event-group.model';

@Injectable({
  providedIn: 'root',
})
export class EventGroupsSeoFormService {
  constructor(private modalService: NgbModal) {}

  /**
   * Open event group seo form
   * @param eventGroup event group
   */
  public open(eventGroup: null | EventGroup = null): Promise<any> {
    const modal = this.modalService.open(EventGroupsSeoFormComponent, { size: 'xl' as 'lg' });
    modal.componentInstance.eventGroupSeo = eventGroup;
    return modal.result;
  }
}
